module.exports = __webpack_public_path__ + "e3c04bb13202ae43e19b4f0ea1fc0f16.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/spacemarines-vignette-preview-420.webp
// module id = 546
// module chunks = 0